export default __webpack_public_path__ + "static/media/OrderIcon.88419dc4.svg";